import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { Card, Button, Col, Row, Container, Tabs, Tab } from "react-bootstrap";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import CalendarComponent from "../../../../components/CalendarComponent";
import PlanningFrom from "./PlanningForm";
import EventPlanningDetail from "./EventPlaningDetail";
import {
  getServiceRequest,
  addEditServiceRequest
} from "../../../../commons/ServiceRequest";
import TechnicianPlansService from "../../../../services/technicianplan.service";

export default function WorkCalendar() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [data, setData] = useState([]);
  const { showAlert } = useAlert();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [selectedTab, setSelectedTab] = useState("EventplaningCalendar");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    handleChangeTab("EventplaningCalendar");
    if (state === "EventPlanning" || state == null) {
      setTimeout(() => setWebsiteName("ปฏิทินงานช่าง"), 300);
    }
  }, []);

  const handleChangeTab = (key) => {
    switch (key) {
      case "EventplaningDetail":
        setWebsiteName("ข้อมูลการวางแผน");
        setSelectedTab("EventplaningDetail");
        break;
      case "EventPlanning":
        setWebsiteName("หัวหน้าวางแผนงาน");
        setSelectedTab("EventPlanning");
        break;
      default:
        setWebsiteName("ปฏิทินงานช่าง");
        setSelectedTab("EventplaningCalendar");
    }
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianPlansService.getAllTechnicianPlans(),
      callback: (res) => pSetData(res)
    });
  }, []);

  const pSetData = (vData) => {
    const colorMap = {}; // To store generated colors for each title
    const newArray = vData.map((items) => {
      const title = items.Technician.Tech_Mas_Name;

      // Check if color is already assigned for this title
      if (!colorMap[title]) {
        colorMap[title] = getRandomHexColor();
      }

      return {
        title: title,
        start: new Date(items.Job_Actual_Date),
        end: new Date(items.Job_Actual_Date),
        hexColor: colorMap[title]
      };
    });
    setData(newArray);
  };

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state || "EventplaningCalendar"}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="EventPlanning" title="หัวหน้าวางแผนงาน" disabled></Tab>
          <Tab
            eventKey="EventplaningDetail"
            title="ข้อมูลการวางแผน"
            disabled
          ></Tab>
          <Tab eventKey="EventplaningCalendar" title="ปฏิทินงานช่าง">
            <Container fluid className="p-0">
              <Card className="m-1 mb-4 p-4 border-0">
                <Card.Header className="p-3 pb-1 bg-transparent border-bottom-0">
                  <Card.Title className="mb-0 fs-2 text-center">
                    แผนงานของช่างปฎิบัติงาน
                  </Card.Title>
                </Card.Header>

                <Card.Body>
                  <CalendarComponent events={data} />
                </Card.Body>
              </Card>
              <Row className="mt-3 text-center">
                <Col className="mt-3">
                  <Button
                    type="submit"
                    variant="outline-secondary"
                    className="me-2 px-5 py-2 text-dark rounded-pill"
                    onClick={() =>
                      navigate("/service_work/planning", {
                        state: "EventPlanning"
                      })
                    }
                  >
                    ย้อนกลับ
                  </Button>
                </Col>
              </Row>
            </Container>
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}

function getRandomHexColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";

  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }

  return color;
}
